import { forwardRef, memo } from 'react';

interface StepsProps {
  steps: number;
  step: number;
}

const StepsBase = ({ steps, step }: StepsProps, ref: React.ForwardedRef<HTMLDivElement>) => {
  return (
    <div ref={ref} className="relative flex items-center gap-2">
      {Array.from({ length: steps }).map((_, index) => (
        <div key={index} className="w-8 h-1.5 rounded-[100px] bg-bg-inter-secondary-pressed" />
      ))}

      <div
        className="absolute w-8 h-1.5 rounded-[100px] bg-bg-inter-primary-active transition-transform duration-300 ease-in-out"
        style={{
          transform: `translateX(${step * (32 + 8)}px)`, // 32px (w-8) + 8px (gap-2)
        }}
      />
    </div>
  );
};

export const Steps = memo(forwardRef(StepsBase));
